import { Box, Button, FormControlLabel, Modal, Radio, RadioGroup, Typography } from '@mui/material'
import { borderRadius, Stack } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { creditformStore, EntityV2Store, loginStore } from '../state/CommonState'
import EntityApi from '../state/entity-api'
import EntityV2Api from '../state/entities-api'
import { PAYMENT_TERMS_CONTENT, PAYMENT_TERMS_TYPE } from '../util/constants'
import CreditsApis from '../state/credit-api'
import LabeledTextField from './LabeledTextField'

const CreditList = () => {

   let Entity = EntityV2Store.EntityRec
   let Credit = creditformStore.CreditformRec

   const defaultForm = useForm({
    defaultValues: creditformStore.CreditformRec 
  });

    const [openPopUp , setOpenPopUp] = useState(false)
    const { control , handleSubmit , setValue , getValues } = defaultForm;
      const [isCreditCustomer, setIsCreditCustomer] = useState(false);



   useEffect(()=> {
  async function checkCreditStatus () {
    if(!Entity.paymentTerms){
      Entity.paymentTerms = {
        type : "",
        approved : false ,
        consentSent : false ,
        approvedBy : "",
        confirmLater: false
      }
    }
    const data = await CreditsApis.checkCaf(Entity.entityId, (response) => {
      if (response.status === true) {
        setIsCreditCustomer(true)
        creditformStore.CreditformRec.set(response.data);
        Entity.paymentTerms.type= 'Credit'
       } else if (response.status === 204) {
        setIsCreditCustomer(false)       
      }
    });
  }
    checkCreditStatus()

   }, [])


    const  onSubmit =async (x) => {
       let paymentTerms
       const isAccept = x === 'accept';
       const isAcceptLater = x === 'acceptLater';
       
       if (isAccept || isAcceptLater) {
         paymentTerms = {
           type: Entity.paymentTerms.type,
           consentSent: Entity.paymentTerms.consentSent,
           approved: isAccept,
           approvedBy: isAccept ? loginStore?.email : '',
           confirmLater: isAcceptLater,
         };
       }
   
       let obj = {
         entityId : Entity.entityId ,
         paymentTerms : paymentTerms
        } 
        EntityV2Api.approvePaymentTerms(obj, (data)=>{
          setOpenPopUp(false)
          Entity.paymentTerms = obj
          window.location.reload()
        });
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      bgcolor: 'background.paper',
      // border: '2px solid #000',
      borderRadius : "10px",
      boxShadow: 24,
      p: 4,
    };

  return (
    <Box sx={{
      flex: 1, backgroundColor: "white", borderRadius: "10px", display: "flex", flexDirection: "column", padding: "10px", overflowY: "auto", "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#2A6ED4 !important", height: "100%", width: "100%"
      }
    }}>
    { isCreditCustomer && <>
      <Typography variant="h6" sx={{ fontWeight: 600, color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>Payment Terms : {Entity.paymentTerms.type}</Typography>
              <Stack direction='row' spacing={1} pb={2} width='50%'  sx={{ display: 'flex', justifyContent: "space-between" }}>
                <LabeledTextField  width='48%' labelStyle={{ color: "black", fontFamily: "Figtree", fontSize: "14px" }} textfieldStyles={{ background: "#fafafa" }} fontSize="14px" label="Duration" control={control} name="duration" disabled = {true}/>
                <LabeledTextField  width='48%' labelStyle={{ color: "black", fontFamily: "Figtree", fontSize: "14px" }} textfieldStyles={{ background: "#fafafa" }} fontSize="14px" label="Credit Amount" control={control} name="creditlimit" disabled = {true}/>
                </Stack>  
    </> 
    }
    { !isCreditCustomer && <>
      <Typography variant="h6" sx={{ fontWeight: 600, color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>Payment Terms : {Entity.paymentTerms.type}</Typography>
      {(Entity.paymentTerms.consentSent  && !Entity.paymentTerms.approved ) &&
      <>
        <Typography variant="p" sx={{ fontWeight: 400 , marginTop : "3%"  }}>
        Dear Sir/ Ma’am,
        </Typography>
       
        { Entity.paymentTerms.type === PAYMENT_TERMS_TYPE.BEFORE_BL_RELEASE &&  <>
          <Typography variant="p" sx={{ fontWeight: 400  }}>
          {PAYMENT_TERMS_CONTENT.BEFORE_BL_RELEASE[0]}  
          </Typography>
          <Typography variant="p" sx={{ fontWeight: 400  }}>
        {PAYMENT_TERMS_CONTENT.BEFORE_BL_RELEASE[1]}   
        </Typography>
        </>
         }
         { Entity.paymentTerms.type === PAYMENT_TERMS_TYPE.SHIPMENT_ON_HAND &&  <>
          <Typography variant="p" sx={{ fontWeight: 400  }}>
          {PAYMENT_TERMS_CONTENT.SHIPMENT_ON_HAND[0]}  
          </Typography>
          <Typography variant="p" sx={{ fontWeight: 400  }}>
        {PAYMENT_TERMS_CONTENT.SHIPMENT_ON_HAND[1]}   
        </Typography>
        </>
         } 
        <Box sx={{ display: 'flex', justifyContent: "left" , marginTop : "2%", marginBottom : "5%"}}>
          <Button variant='contained' p={2} onClick={() => onSubmit('accept')}>Accept</Button>
          <Button variant='outlined' sx={{ ml: 1 }} type="submit" onClick={() => {
           onSubmit('acceptLater');
          }} >Approve Later</Button>
        </Box>
        </>     
         
      }      
      {(Entity.paymentTerms.consentSent === true  && Entity.paymentTerms.approved === true ) &&
        <Typography variant="p" sx={{ fontWeight: 400 , marginBottom : "10%" }}>
          Payment terms approved by {Entity.paymentTerms.approvedBy}.
        </Typography>
      }

      {Entity.paymentTerms.consentSent === false &&
        <Box sx={{}}>
        <Typography variant="p" sx={{ fontWeight: 400 }}>
          Payment terms has not been initiated .
        </Typography>
        </Box>
      }
      </>
    }
    </Box>
  )
}

export default CreditList
